'use client'

import { useState, useEffect } from 'react'
import Image, { ImageProps } from 'next/image'

interface CustomImageProps extends ImageProps {
  fallbackSrc?: string
}

const CustomImage: React.FC<CustomImageProps> = ({ src, alt, fallbackSrc = '/assets/images/no-image.png', ...props }) => {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) {
    return <Image src={fallbackSrc} alt="Fallback image" loading="eager" {...props} />
  }

  return <Image src={src} alt={alt} loading="eager" {...props} />
}

export default CustomImage
